import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfService } from 'src/conf.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiConfig } from 'src/app/config/apiConfig';

@Injectable({
  providedIn: 'root'
})
export class LabManagerService {

  private rootUrl: string;
  private labManagerAPIUrl;
  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.labManagerAPIUrl = ApiConfig.LabManagerApiConfig;

  }

  getLabModels(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.getLabModels}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabTestByModel(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.getLabTestByModel}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  getAllLabTestsAndProfiles(ObjParam: any=null): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.getAllLabTestsAndProfiles}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabFrequencyAlertsRule(): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.getLabFrequencyAlertsRule}`,{})
      .pipe(
        tap(() => {
          //
        })
      );
  }
  updateLabFrequencyAlertRule(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.updateLabFrequencyAlertRule}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getStateException(): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.getStateException}`,{})
      .pipe(
        tap(() => {
          //
        })
      );
  }
  UpdateStateException(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.UpdateStateException}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  updateLabTestByModel(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.updateLabTestByModel}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabRangeAlertRules(): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.getLabRangeAlertRules}`,{})
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabRangeAlertRuleByTest(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.getLabRangeAlertRuleByTest}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  updateLabRangeAlertRule(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.updateLabRangeAlertRule}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  updateLabTestAndProfileStatus(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labManagerAPIUrl.updateLabTestAndProfileStatus}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
}
